import ApiService from './';
import { deleteStageParams, StageOrderParams, StageParams, updateStageParams } from '../params/pipeline';

/**
 * @heading1: Stage API service.
 *
 * Provides a collection of methods to interact with the Stage API.
 * Includes operations for managing stages functionalities.
 */

const StageApi = {
    /**
 * @heading3: Create Stage
 * @paragraph: Sends a POST request to create a new stage within a pipeline.
 * @param: {string} token - The user's authentication token.
 * @param: {StageParams} data - The data required to create the stage.
 */
    createStage: (token: string, data: StageParams) => {
        return ApiService.apiHit({
            url: 'stage',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
 * @heading3: Update Stage Order
 * @paragraph: Sends a POST request to update the order of stages in a pipeline.
 * @param: {string} token - The user's authentication token.
 * @param: {StageOrderParams} data - The new order of stages.
 */
    updateStageOrder: (token: string, data: StageOrderParams) => {
        return ApiService.apiHit({
            url: 'update-stage-order',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
 * @heading3: Delete Stage
 * @paragraph: Sends a POST request to delete a stage from a pipeline.
 * @param: {string} token - The user's authentication token.
 * @param: {deleteStageParams} data - The ID of the stage to delete.
 */
    deleteStage: (token: string, data: deleteStageParams) => {
        return ApiService.apiHit({
            url: 'delete-stage',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    /**
 * @heading3: Update Stage
 * @paragraph: Sends a POST request to update the details of an existing stage.
 * @param: {string} token - The user's authentication token.
 * @param: {updateStageParams} data - The updated stage details.
 */
    updateStage: (token: string, data: updateStageParams) => {
        return ApiService.apiHit({
            url: 'edit-stage',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default StageApi;
